import CorrectnessTally from './CorrectnessTally.jsx';
import './NumericQuestion.css';

const TOP_VALUES = 3;

/**
 * Projector view of a numeric question. Hidden while answering, so nobody
 * answers by reading the room; on reveal it shows the three most-typed
 * answers side by side, which is the moment the class sees that `15` and
 * `15.0` were both typed and only one of them is what Python prints.
 */
export default function HostNumericPreview({ payload, revealed, tally }) {
  if (!revealed) {
    return (
      <div className="stack host-numeric-stack">
        <div className="numeric-expression host-numeric-expression num">
          <span>{payload.expression}</span>
          <span className="numeric-eq">=</span>
          <span className="numeric-slot">?</span>
        </div>
        {payload.hint && <p className="host-numeric-note">{payload.hint}</p>}
      </div>
    );
  }

  const values = (tally?.values || []).slice(0, TOP_VALUES);
  const top = values.reduce((max, v) => Math.max(max, v.count), 0) || 1;

  return (
    <div className="stack host-numeric-stack">
      <div className="numeric-expression host-numeric-expression num">
        <span>{payload.expression}</span>
        <span className="numeric-eq">=</span>
        <span className="numeric-slot is-correct">{payload.answer}</span>
      </div>

      {values.length > 0 && (
        <div className="host-numeric-values">
          {values.map((v) => (
            <div
              key={v.text}
              className={`host-numeric-value-row ${v.text === payload.answer ? 'is-answer' : ''}`}
            >
              <span className="host-numeric-value">{v.text}</span>
              <span className="host-numeric-track">
                <span className="host-numeric-fill" style={{ width: `${Math.round((v.count / top) * 100)}%` }} />
              </span>
              <span className="host-numeric-count">{v.count} คน</span>
            </div>
          ))}
        </div>
      )}

      {payload.revealNote && <p className="host-numeric-note">{payload.revealNote}</p>}

      <CorrectnessTally tally={tally} />
    </div>
  );
}
